// frontend/src/router/routes/bookingRoutes.tsx
// FIXED: Smart role-based booking routes that resolve correctly for providers

import { Route } from "react-router-dom";
import ProtectedRoute from "@/components/auth/ProtectedRoute";
import BookingManagement from "@/pages/BookingManagement";
import BookingDetailPage from "@/pages/BookingDetailPage";

export const bookingRoutes = [
  // =====================================
  // 🔷 CUSTOMER BOOKING ROUTES (Customer Account Layout)
  // HIGHEST PRIORITY - Most specific paths with /account prefix
  // =====================================
  <Route
    key="customer-bookings"
    path="/account/bookings"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <BookingManagement context="customer" />
      </ProtectedRoute>
    }
  />,
  <Route
    key="customer-bookings-pending"
    path="/account/bookings/pending"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <BookingManagement context="customer" />
      </ProtectedRoute>
    }
  />,
  <Route
    key="customer-bookings-accepted"
    path="/account/bookings/accepted"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <BookingManagement context="customer" />
      </ProtectedRoute>
    }
  />,
  <Route
    key="customer-bookings-completed"
    path="/account/bookings/completed"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <BookingManagement context="customer" />
      </ProtectedRoute>
    }
  />,
  <Route
    key="customer-booking-detail"
    path="/account/bookings/:id"
    element={
      <ProtectedRoute requiredRoles={["user", "customer"]} layout="customer-account">
        <BookingDetailPage />
      </ProtectedRoute>
    }
  />,

  // =====================================
  // 🎯 SHARED BOOKING ROUTES - ROLE-BASED LAYOUT DETECTION
  // These routes work for both ADMIN and PROVIDER with automatic layout detection
  // =====================================
  
  // Booking detail route - automatically detects admin vs provider layout
  <Route
    key="shared-booking-detail"
    path="/bookings/:id"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <BookingDetailPage />
      </ProtectedRoute>
    }
  />,
  
  // Booking status routes - automatically detects admin vs provider layout
  <Route
    key="shared-bookings-pending"
    path="/bookings/pending"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <BookingManagement />
      </ProtectedRoute>
    }
  />,
  <Route
    key="shared-bookings-accepted"
    path="/bookings/accepted"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <BookingManagement />
      </ProtectedRoute>
    }
  />,
  <Route
    key="shared-bookings-completed"
    path="/bookings/completed"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <BookingManagement />
      </ProtectedRoute>
    }
  />,
  
  // General booking route - automatically detects admin vs provider layout
  <Route
    key="shared-bookings"
    path="/bookings"
    element={
      <ProtectedRoute requiredRoles={["admin", "super_admin", "provider"]}>
        <BookingManagement />
      </ProtectedRoute>
    }
  />,
];

// NOTE: The context prop is now automatically determined in BookingManagement
// based on the user's role. No need to pass it explicitly.